import React from 'react';
import Icon from '../../../components/AppIcon';


const QuickActions = ({ onAction }) => {
  const quickActions = [
    {
      id: 'bulk-publish',
      title: 'Bulk Publish',
      description: 'Publish all draft readings at once',
      icon: 'Upload',
      variant: 'default',
      action: () => onAction('bulk-publish')
    },
    {
      id: 'export-stats',
      title: 'Export Statistics',
      description: 'Download client progress report',
      icon: 'Download',
      variant: 'outline',
      action: () => onAction('export-stats')
    },
    {
      id: 'backup-content',
      title: 'Backup Content',
      description: 'Create backup of all curriculum data',
      icon: 'Archive',
      variant: 'outline',
      action: () => onAction('backup-content')
    },
    {
      id: 'send-notifications',
      title: 'Send Notifications',
      description: 'Notify inactive clients',
      icon: 'Bell',
      variant: 'secondary',
      action: () => onAction('send-notifications')
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg shadow-gentle p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg">
          <Icon name="Zap" size={20} className="text-accent" />
        </div>
        <div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            Quick Actions
          </h2>
          <p className="text-sm text-muted-foreground">
            Common administrative tasks
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {quickActions?.map((action) => (
          <div
            key={action?.id}
            className="group p-4 border border-border rounded-lg hover:border-primary/20 hover:bg-primary/5 transition-all duration-200 cursor-pointer"
            onClick={action?.action}
          >
            <div className="flex flex-col items-center text-center space-y-3">
              <div className="flex items-center justify-center w-12 h-12 bg-muted group-hover:bg-primary/10 rounded-lg transition-colors duration-200">
                <Icon 
                  name={action?.icon} 
                  size={20} 
                  className="text-muted-foreground group-hover:text-primary transition-colors duration-200"
                />
              </div>
              
              <div>
                <h3 className="font-caption font-semibold text-foreground group-hover:text-primary transition-colors duration-200">
                  {action?.title}
                </h3>
                <p className="text-xs text-muted-foreground mt-1">
                  {action?.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Recent Activity */}
      <div className="mt-8 pt-6 border-t border-border">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Recent Activity
        </h3>
        
        <div className="space-y-3">
          <div className="flex items-center space-x-3 p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center justify-center w-8 h-8 bg-success/10 rounded-lg">
              <Icon name="CheckCircle" size={16} className="text-success" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground">
                Published "Day 15: Finding Purpose" reading
              </p>
              <p className="text-xs text-muted-foreground">2 hours ago</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3 p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-lg">
              <Icon name="UserPlus" size={16} className="text-primary" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground">
                New client registered: Sarah Johnson
              </p>
              <p className="text-xs text-muted-foreground">5 hours ago</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3 p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center justify-center w-8 h-8 bg-warning/10 rounded-lg">
              <Icon name="Calendar" size={16} className="text-warning" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground">
                Reset start date for Michael Chen
              </p>
              <p className="text-xs text-muted-foreground">1 day ago</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;